import { Trans } from '@lingui/react/macro'

export function LoadingSpinner() {
  return (
    <div
      className="flex min-h-[200px] items-center justify-center"
      role="status"
    >
      <div
        className="border-primary h-8 w-8 animate-spin rounded-full border-4 border-t-transparent"
        aria-hidden="true"
      />
      <span className="sr-only">
        <Trans>Loading...</Trans>
      </span>
    </div>
  )
}
